<template>
    <pm-app-component id="pm-smart-plan" :key="$store.state.dentalNotation" hide-sidebar bar-color="#ec3c7a!important">
        <!-- TOOLBAR START -->

        <template slot="mobile-toolbar" v-if="packageName === 'com.denticalc.4in1'">
            <pm-application-bar>
                {{ $t('menu.treatment_plan') }}
            </pm-application-bar>

            <v-menu offset-y>
                <span slot="activator" class="white--text">
                    {{ $t('plan_calculator.plan_number', {n: planIdMap[activePlan].toUpperCase() }) }}
                    <v-icon>arrow_drop_down</v-icon>
                </span>
                <div class="pm-smart-plan-selector-menu" style="width: 150px;">
                    <template v-for="planId in ['a','b','c']">
                        <div class="pm-smart-plan-selector-menu-item"
                                v-if="planIdMap.includes(planId)"
                            @click="activePlan = planIdMap.indexOf(planId)"
                            :style="activePlan !== planIdMap.indexOf(planId) ? 'color: rgba(0,0,0,.5)' : 'color: rgba(0,0,0,1)'">

                            <b style="flex-grow: 1; font-weight: 600!important;">{{ $t('plan_calculator.plan_number', {n: planId.toUpperCase() }) }}</b>
                            <v-icon v-if="plans.length > 1 && planIdMap.indexOf(planId) === activePlan" style="color: #000; padding: 6px 6px 6px 4px; font-size: 16px;" @click.stop="deletePlan(planIdMap.indexOf(planId))" v-text="'close'" />
                        </div>
                    </template>
                    <div class="pm-smart-plan-selector-menu-item" @click="createPlan">
                        <v-icon id="add-treatment" style="font-size: 24px;" v-text="'add'" />
                    </div>
                </div>
            </v-menu>

        </template>

        <template v-else slot="mobile-toolbar">
            <div style="flex-grow: 1; position: relative;">
                <template v-for="planId in ['a','b','c']">

                    <v-btn flat outline :key="planId" ripple style="border: 0px solid #f00!important; min-width: 30%; margin: 0; padding: 0 8px; text-transform: none;" v-if="planIdMap.includes(planId)"
                    @click="activePlan = planIdMap.indexOf(planId)"
                           :style="activePlan !== planIdMap.indexOf(planId) ? 'color: rgba(255,255,255,.5)' : ''"
                    >
                        <b style="font-weight: 600!important;">{{ $t('plan_calculator.plan_number', {n: planId }) }}</b>
                        <v-icon v-if="plans.length > 1 && planIdMap.indexOf(planId) === activePlan" style="padding: 6px 6px 6px 4px; margin-left: 4px; margin-top: 2px;font-size: 16px;" @click.stop="deletePlan(planIdMap.indexOf(planId))" v-text="'close'" />
                    </v-btn>

                </template>
            </div>
            <v-icon id="add-treatment" style="font-size: 24px;" @click.stop="createPlan" v-text="'add'" />


        </template>



        <!-- TOOLBAR END -->

        <!-- ACTIVE TREATMENT TITLE START -->
        <div id="pm-smart-header" v-if="selectedDetails === ''">
            <pm-jaw-header :showPrice="showOverview || !showSelector" v-show="$store.state.simplePlan.availableTreatmentPids.length > 0" :key="$store.state.currency" ref="pmJawHeader" :jaw="$store.state.simplePlan.selectedJaw" />
            <pm-jaw-header-placeholder :selected-regions="selectedRegions" />
        </div>
        <!-- ACTIVE TREATMENT TITLE END -->

        <!-- REGION SELECTOR START -->
        <div v-show="!showOverview && showSelector" :class="[$theme.contentBg, 'pm-plan-selector-container', 'pm-plan-selector-container--default']">
            <div class="pm-plan-selector-flex-inner">
                <div class="pm-plan-selector-region-column">
                    <pm-region-selector ref="pmRegionSelector" :steps="steps" @select="selectArea" />
                </div>
                <div class="pm-plan-selector-treatment-column">
                    <pm-simple-treatment-selector ref="treatmentSelector" @select="selectTreatment" v-once />
                </div>
            </div>
        </div>
        <!-- REGION SELECTOR END -->

        <!-- RANGE EDITOR START -->
        <div v-show="!showOverview && showSelector" :class="['show-selector', 'tooth-selector', $theme.contentBg]">
            <pm-simple-treatment-settings
                ref="pmTreatmentSettings"
                style="width: 100%;"
                :selected-region="selectedRegions[0]"
                :steps="steps"
                @selectRegion="setSelectedRegion"
                @updated="treatmentSettingsUpdated"
            />
        </div>
        <!-- RANGE EDITOR END -->

        <!-- OVERVIEW SELECTOR START -->
        <transition>
            <div v-show="showOverview || !showSelector"

                 style="background: rgba(240,240,240,.94); box-shadow: 0 0 10px rgba(0,0,0,.35); border: 1px solid #fff;  overflow: visible; position: absolute; left: 0; right: 0; bottom: 0px; z-index: 3; height: 60px;"
                 class="bottom-overview-selector-wrapper"
            >
                <div style="display: flex; justify-content: center; align-items: center; height: 60px; padding: 0 12px;">
                    <v-btn
                        v-for="item in ['upper', 'lower', 'extras', 'total']"
                        :id="`selector--${item}`"
                        :key="item"
                        flat
                        small
                        :class="selectedDetails === item ? 'pink--text' : 'grey--text text--darken-1'"
                        style="height: 60px; flex-grow: 1; min-width: 0; margin: 0 8px; position:relative;"
                        @click="selectedDetails = item"
                    >
                        <span class="roboto bold--text">{{ $t("plan_calculator." + item) }}</span>
                        <div style="transition: all .5s; position: absolute; bottom: -16px; height: 2px;"
                             :style="selectedDetails === item ? 'background: #E91E63; left: 0%; right: 0%;' : 'background: #fff; left: 50%; right: 50%;'"
                        />
                    </v-btn>
                </div>
            </div>
        </transition>
        <!-- OVERVIEW SELECTOR END -->

        <!-- JAW DETAILS START -->
        <transition name="pm-fade-transition">
            <div v-if="selectedDetails">
                <div v-if="selectedDetails === 'upper' || selectedDetails === 'lower'" :key="selectedDetails" class="treatment-details-wrapper" style="overflow: auto; position: absolute; top: 0; z-index: 2; left: 0; right: 0; background-color: #fff!important; bottom: 0px; padding-bottom: 60px; z-index: 2;">
                    <pm-treatment-details
                        :key="activePlan"
                        :jaw="selectedDetails"
                        :steps="steps"
                        style="width: 100%;"
                        @updated="storeComponentState"
                    />
                </div>
                <div v-if="selectedDetails === 'extras'" :key="selectedDetails" style="overflow: auto; position: absolute; top: 0; z-index: 2; left: 0; right: 0; background-color: #fff!important; bottom: 0px; padding-bottom: 60px; z-index: 2;">
                    <pm-additional-treatments @updated="storeComponentState" />
                </div>
            </div>
        </transition>
        <!-- JAW DETAILS END -->

        <!-- OVERVIEW START -->
        <!--transition :name="detailsTransition"-->
        <div v-show="showOverview" class="overview-header-wrapper" style="overflow: auto; position: absolute; top: 0; z-index: 2; left: 0; right: 0; background-color: #fafafa!important; bottom: 0px; padding-bottom: 60px; z-index: 2;">
            <div id="overview-content">

                <pm-overview-header v-if="selectedDetails !== 'total'" :key="$store.state.currency" ref="overviewHeader" @close="showOverview = false" />
                <pm-overview-header v-if="selectedDetails === 'total'" :key="$store.state.currency" ref="overviewHeader" @close="showOverview = false" />

                <div style="box-shadow: 0 8px 15px rgba(0,0,0,.03);">
                    <template v-for="jaw in ['upper','lower']">
                        <pm-treatment-overview :key="jaw + $store.state.currency" :jaw="jaw" @click.native="selectedDetails = jaw" />
                    </template>

                    <pm-extras-overview :key="$store.state.currency" @click.native="selectedDetails = 'extras'" />

                    <pm-discount-overview v-if="$store.state.simplePlan.discountAmount > 0" :key="$store.state.currency" @click.native="selectedDetails = 'extras'" />
                </div>
            </div>

            <div v-if="proFunctionsAreAvailable" class="flex flex-centered white btn--wrapper" style="margin: 0 5px; padding-bottom: 16px; margin-top: 16px; flex-wrap: wrap; justify-content: space-evenly">

                <div style="display: flex; flex-direction: row; justify-content: space-between; width: 100%; max-width: 270px; margin: 20px 40px 0 40px;">
                    <div style="font-weight: 600; color: #2979ff; text-align: center;" @click="save">
                        <div style="margin-bottom: 4px; width: 60px; height: 60px; text-align: center; padding: 13px 0; border-radius: 50%; border: 2px solid #2979ff;">
                            <mdi size="32" style="color: #2979ff;">mdiContentSaveOutline</mdi>
                        </div>
                        Save
                    </div>
                    <div style="font-weight: 600; color: #2979ff; text-align: center;"  @click="openPrintInfoDialog('send')">
                        <div style="margin-bottom: 4px; width: 60px; height: 60px; text-align: center; padding: 13px 0; border-radius: 50%; border: 2px solid #2979ff;">
                            <mdi size="32" style="color: #2979ff;">mdiEmailSendOutline</mdi>
                        </div>
                        Send
                    </div>
                    <div style="font-weight: 600; color: #2979ff; text-align: center;" @click="openPrintInfoDialog('print')">
                        <div style="margin-bottom: 4px; width: 60px; height: 60px; text-align: center; padding: 13px 0; border-radius: 50%; border: 2px solid #2979ff;">
                            <mdi size="32" style="color: #2979ff;">mdiPrinter</mdi>
                        </div>
                        Print
                    </div>
                </div>

                <!-- <div style="text-align: center; padding: 10px 0">
                    <v-btn
                        class="roboto f13 blue--text text--accent-3 bold--text btn--save-calc"
                        flat
                        style="margin: 0 !important; height: auto; border: 2px solid #2962ff!important; padding: 4px 16px; border-radius: 24px"
                        @click="save"
                    >
                        <v-icon
                            style="margin-right: 8px"
                            v-text="'save_outline'"
                        />
                        {{ $t('plan_calculator.save_plan') }}
                    </v-btn>
                </div>

                <div style="margin: 0 5px; text-align: center; padding: 10px 0" v-if="showEmailButton">
                    <v-btn
                        class="roboto f13 blue--text text--accent-3 bold--text btn--email-send"
                        flat
                        style="margin: 0 !important; height: auto; border: 2px solid #2962ff!important; padding: 4px 16px; border-radius: 24px; position: relative;"
                        @click="sendPlan"
                    >
                        <v-icon style="margin-right: 8px" v-text="'email_send_outline'" />
                        <div v-if="$store.state.simplePlan.emailSent" class="green" style="border-radius: 50%; position: absolute; height: 22px; width: 22px; padding: 0; right: 0; margin: -12px -24px 0 0;"><v-icon style="line-height: 1; margin: -7px 0 0 0; font-size: 14px;" class="white--text">check</v-icon></div>
                        {{ $t('send_email.send') }}
                    </v-btn>
                </div>

                <div style="margin: 0 5px; text-align: center; padding: 10px 0" v-if="showEmailButton">
                    <v-btn
                        class="roboto f13 blue--text text--accent-3 bold--text btn--email-send"
                        flat
                        style="margin: 0 !important; height: auto; border: 2px solid #2962ff!important; padding: 4px 16px; border-radius: 24px; position: relative;"
                        @click="printPlan"
                    >
                        <mdi style="margin-right: 8px">mdiPrinter</mdi>
                        Print
                    </v-btn>
                </div> -->
            </div>
        </div>
        <!--/transition-->
        <!-- OVERVIEW END -->

        <pm-3d-animation-viewer v-model="animationViewDialog" :animation-data="animationData" :title="$t('plan_calculator.plan_number', {n: numero })" />
        <pm-product-tour v-if="tutorialMode" :parent-data="$data" @callMethod="callMethod" />
        <pm-send-dialog :animationData="animationData" :activePlan="planIdMap[activePlan]" ref="email-send-dialog" v-if="emailDialogVisible" v-model="emailDialogVisible" @close="emailDialogVisible = false" @sent="emailSent">
            <div slot="content" v-if="emailDialogVisible" id="email-content" style="overflow: hidden; height: 0px;">
                <div style="box-shadow: 0 8px 15px rgba(0,0,0,.03);">
                    <template v-for="jaw in ['upper','lower']">
                        <pm-treatment-overview-email :jaw="jaw" :key="jaw + $store.state.currency" />
                    </template>
                    <pm-extras-overview-email :key="$store.state.currency" />
                </div>
                <pm-overview-header-email :key="$store.state.currency" />
            </div>
        </pm-send-dialog>



        <!--pm-print-info-dialog v-if="printInfoDialogVisible" :btn="printInfoDialogButton" @send="closePrintInfoDialog('send')" @print="closePrintInfoDialog('print')"></pm-print-info-dialog-->

        <pm-pdf-template v-if="printDialogVisible" :animationData="animationData" ref="smartPdfTemplate" />

        <pm-plan-simple-tutorial />

        <pm-premium-lock-screen v-if="!$IAP.hasAccessToComponent('smart')" />

        <!-- <pm-pdf-viewer v-model="pdfData" v-if="pdfData !== null" /> -->

        <!-- <pm-welcome-screen v-if="onboarding.length > 0" :steps="onboarding" /> -->

    </pm-app-component>
</template>

<style lang="scss">
    #pm-smart-plan {
    }
    #pm-smart-header {

    }

    #pm-smart-plan {
        height: 100vh;
    }

    .pm-plan-selector-container {
        box-shadow: 0 8px 30px rgba(0,0,0,.03);
        overflow: hidden;
        position: absolute;
        top: 72px;
        left: 0;
        right: 0;
        z-index: 0;
        transition: all .4s;
        transform: translateZ(0);
        bottom: 170px!important;
        height: calc(100vh - 358px);

        @media (min-width: 700px) {
            /*height: calc(100vh - 418px);*/
        }
    }

    .pm-plan-selector-flex-inner {
        height: 100%;
    }

    $treatmentButtonsMinWidth: 300px;

    .pm-plan-selector-region-column {
        height: 100%;
        max-height: calc(100vh - 358px)!important;
        width: Max(55%, calc(100% - (#{$treatmentButtonsMinWidth} + 16px)));
        float: left;
        overflow: visible;
        display: flex;
        justify-content: center;
        align-items: center;

        margin: 0 16px;
        @media (min-width: 700px) {
            .pm-plan-selector-container & {
                width: Max(60%, calc(100% - (#{$treatmentButtonsMinWidth} + 32px)));
            }
        }
    }
    .pm-plan-selector-treatment-column {
        height: 100%;
        width: Min(calc(45% - 32px), #{$treatmentButtonsMinWidth});

        overflow: hidden;
        position: relative;
        z-index: 2;

        @media (min-width: 700px) {
            .pm-plan-selector-container & {
                width: Min(calc(40% - 32px), #{$treatmentButtonsMinWidth});
            }
        }
    }

    .tooth-selector {
        transition-delay: 0.2s;
        overflow: visible;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 20px;
        z-index: 1;
        transition: all .4s;
        box-shadow: 0 8px 15px rgba(0,0,0,.03);
        height: 130px;
    }

    @media (min-width: 700px) {
        .tooth-selector {
            height: 140px;
            bottom: 30px;
        }
    }


    #pm-smart-plan .v-tabs__item:not(.v-tabs__item--active) {
        opacity: .4;
    }







    .offline-disabled {
        filter: grayscale(1);
        opacity: 0.5;
    }

    .pm-smart-plan-selector-menu-item {
        height: 40px; align-items: center; display: flex; padding: 0 10px; border-bottom: 1px solid #eee;
    }

@media (min-width: 700px) {

    .btn--wrapper {
        height: 120px;
    }

    .btn--save-calc,
    .btn--email-send {
        font-size: 18px;
        top: 5px;
        line-height: 38px!important;
        padding: 4px 24px!important;
    }

    .bottom-overview-selector-wrapper {
        height: 62px !important;
        bottom: 18px !important;
    }

    .bottom-overview-selector-wrapper button {
        font-size: 17px;
    }

    .bottom-overview-selector-wrapper button div div {
        bottom: -16px !important;
    }

    .bottom-overview-selector-wrapper > div {
        height: 62px !important;
    }
    .pm-smart-plan-selector-menu {
        font-size: 18px;
    }
    .pm-smart-plan-selector-menu-item {
        height: 60px;
        padding: 0 16px;
    }

}
</style>

<script>
import ToolbarMixin from "../../extensions/mixins/mixin-toolbar";
import SimplePlanStore from "../../extensions/vuex/store-simple-plan";
import SimplePlanService from "../../extensions/services/plan-simple-service";
import PlanAnimationService from "../../extensions/services/plan-animation-service";
import PmRegionSelector from "./region-selector";
import PmSimpleTreatmentSelector from "./treatment-selector";
import PmTreatmentDetails from "./treatment-details";
import PmOverviewHeader from "./overview-header";
import PmSimpleTreatmentSettings from "./treatment-settings";
import Pm3dAnimationViewer from "./3d-animation-viewer";
import PlanSimpleStatusGenerator from "../../extensions/services/plan-simple-status-generator";
// import PmProductTour from "./product-tour";
import PmTreatmentOverview from "./treatment-overview";
import PlanResetService from "../../extensions/services/plan-reset-service";
import PmPlanTabs from "./plan-tabs";
import PmAnimations from "../animations/animations";
import PmJawHeader from "./jaw-header";
import PmAdditionalTreatments from "./additional-treatments";
import PmExtrasOverview from "./extras-overview";
import PmJawHeaderPlaceholder from "./jaw-header-placeholder";

const MINUTES_THRESHOLD = 30;

import historyDb from "../../extensions/services/history-db";
import PmSendDialog from "./dialog-send";
import PmOverviewHeaderEmail from "./overview-header-email";
import PmTreatmentOverviewEmail from "./treatment-overview-email";
import PmExtrasOverviewEmail from "./extras-overview-email";
import PmPlanSimpleTutorial from "./tutorial";
import PmPdfTemplate from "./pdf";

// import PmEmailIcon from "../../configs/icons/email";

import AdManager from '../../extensions/managers/ad-manager';

import { onboarding } from "./onboarding.js";
import { downloadPdf, getPdfFileUrl } from "../../utils/pdf";
import { isDev } from "../../utils/debug/is-dev";
// import PmPdfViewer from "../dialogs/pdf-viewer.vue";

import PmDiscountOverview from "./discount-overview.vue";
import PmPremiumLockScreen from "@/components/core/premium-lock-screen";
import PmPrintInfoDialog from "./print-info-dialog.vue";

export default {
    name: "Plan",
    beforeCreate() {
        if (typeof this.$store.state.simplePlan === "undefined") {
            this.$store.registerModule("simplePlan", SimplePlanStore);
        }
    },
    created() {
        this.currency = this.$store.state.currency;
        this.$store.state.simplePlan.currency = this.currency;
        this.$bus.$on("activePlan:update", ({activePlan}) => {
            this.activePlan = activePlan;
        });

        this.showEmailButton = this.getShowEmailButton();

        this.onboarding = onboarding();
    },
    beforeRouteEnter(to, from, next) {
        if (window.packageName && !['com.denticalc.calculationtool', 'com.denticalc.4in1'].includes(window.packageName)) return(next({name: "home"}));
        AdManager.logRouteView('plan');
        return next();
    },
    async mounted() {
        await this.loadComponentState();

        this.tutorialMode = this.$store.state.simplePlan.tutorialMode || localStorage.getItem("tutorial-mode") === "on";

        window.app.notifyFlutterMounted();

        this.onLoad();

        //if(!this.$IAP.hasAccessToComponent('smart')) this.$bus.$emit('openAppDialog','premium', {'referrer': 'auto_smart'});
        //else

        // if (!localStorage.getItem("smartVideoViewed") && !localStorage.getItem("smartVideoClosed")) this.$bus.$emit('openAppDialog','videoDialog');

    },
    components: {
        // eslint-disable-next-line vue/no-unused-components
        // PmEmailIcon,
        PmPlanSimpleTutorial,
        PmPlanTabs,
        PmTreatmentDetails,
        PmRegionSelector,
        PmSimpleTreatmentSelector,
        PmOverviewHeader,
        PmSimpleTreatmentSettings,
        PmTreatmentOverview,
        Pm3dAnimationViewer,
        // eslint-disable-next-line vue/no-unused-components
        // PmProductTour,
        // eslint-disable-next-line vue/no-unused-components
        PmAnimations,
        PmJawHeader,
        PmAdditionalTreatments,
        PmExtrasOverview,
        PmSendDialog,
        PmOverviewHeaderEmail,
        PmTreatmentOverviewEmail,
        PmExtrasOverviewEmail,
        PmJawHeaderPlaceholder,
        PmPdfTemplate,
        // PmPdfViewer,
        PmDiscountOverview,
        PmPremiumLockScreen,
        PmPrintInfoDialog,
    },
    mixins: [
        ToolbarMixin,
    ],
    toolbar: function() {
        if (!window.packageName) return this.getToolbarItemsDefault();
        else return this.getToolbarItemsPersonalized();
    },
    data() {
        return ({
            IAP: window.IAP,
            selectedRegions: [],
            showSelector: true,
            showSelectorLarge: false,
            selectedRegion: null,
            steps: [],
            status: [],
            ids: [],
            showOverview: false,
            selectedDetails: "",
            plans: ["{}"],
            activePlan: 0,
            animationViewDialog: false,
            animationData: {},
            detailsTransition: "pm-fade-transition",
            primaryTreatments: [],
            resetedJaw: "",
            deletePlanIdx: -1,
            videoViewDialog: false,
            tutorialMode: false, // TODO
            loadingComponentState: false,
            currency: "",
            planIdMap: ['a'],
            emailDialogVisible: false,
            printDialogVisible: false,
            showEmailButton: true,
            // pdfData: null,
            printInfoDialogVisible: false,
            printInfoDialogButton: "email",
        });
    },
    computed: {
        packageName() {
            return window.packageName;
        },
        toggleSelector() {
            return this.showSelectorLarge ? "show-selector" : "hide-selector";
        },
        numero() {
            return ["a", "b", "c"][parseInt(this.activePlan)];
        },
        proFunctionsAreAvailable() {
            const {packageName} = window;

            if (!packageName) return false;
            if (packageName === 'com.denticalc.pro') return true;
            if (packageName === 'com.denticalc.4in1') return true;
        },
        is4in1() {
            return window.packageName === 'com.denticalc.4in1';
        },
    },
    watch: {
        selectedDetails(current, prev) {
            if (prev === "") return;
            if (current === "total") {
                this.showOverview = true;
            } else {
                this.showOverview = false;
            }

            window.Tracker.screenView(`prices-${this.selectedDetails}`);
        },
        showOverview() {
            this.updateToolbar();
        },
        showSelector() {
            this.detailsTransition = "pm-fade-transition";
        },

        selectedRegions() {
            if (this.selectedRegions.length === 0) {
                this.$store.state.simplePlan.selectedRegion = -1;
                this.$store.state.simplePlan.selectedJaw = "";
            } else {
                this.$store.state.simplePlan.selectedRegion = this.selectedRegions[0];
                this.$store.state.simplePlan.selectedJaw = this.selectedRegions[0] < 3 ? "upper" : "lower";
            }

            /*this.$nextTick(()=>{
                this.updateToolbar();
            });*/

            if (this.selectedRegions.length === 0) {
                return;
            } else {
                this.showSelectorLarge = false;
            }
        },

        activePlan(newValue, prevValue) {
            this.handleActivePlanChange(newValue, prevValue);
        },
    },
    beforeDestroy() {
        // this.$store.commit("simplePlan/reset");
        this.$bus.$off("activePlan:update");
    },
    activated() {
        // töltse be a komponens szintű status/step-be ami kell meg $forceUpdate
        this.onLoad();
    },
    methods: {
        openPrintInfoDialog(next) {
            if (next === 'print') this.printPlan();
            else this.sendPlan();

            return;
            this.printInfoDialogVisible = true;
            this.printInfoDialogButton = next;
        },
        closePrintInfoDialog(next) {
            this.printInfoDialogVisible = false;
            if (next === 'print') this.printPlan();
            else this.sendPlan();
        },
        onLoad() {
            if (this.$store.state.simplePlan.openSelectedDetails === true) {
                // this.$store.state.simplePlan.openSelectedDetails = false;

                // this.$nextTick(() => {
                //    this.openDetails();
                // });
            } else {
                this.showOverview = false;
                this.showSelector = true;
                this.videoViewDialog = false;
                this.selectedDetails = "";

                this.updateToolbar();
            }

            if (window.loadFromHistory) {
                this.planIdMap = ['a'];
                this.plans.splice(0, this.plans.length);
                this.activePlan = 0;
                this.plans[this.activePlan] = {};
                this.steps = this.$store.state.simplePlan.steps;
                this.status = this.$store.state.simplePlan.status;
                this.$refs["pmRegionSelector"].selectArea(this.$store.state.simplePlan.selectedRegion);
                this.selectedRegions[0] = this.$store.state.simplePlan.selectedRegion;
                this.$forceUpdate();
                this.$refs["pmTreatmentSettings"].update();
                this.updateToolbar();
                this.$nextTick(()=>{
                    // this.$refs["pmRegionSelector"].deselect();
                    this.$refs["pmRegionSelector"].update();
                    this.$refs["pmRegionSelector"].$forceUpdate();
                    this.$forceUpdate();
                    window.loadFromHistory = false;
                });
            } else {
                if (this.currency !== this.$store.state.currency) this.exchangePrices();
            }


            this.tutorialMode = this.$store.state.simplePlan.tutorialMode || localStorage.getItem("tutorial-mode") === "on";
            this.storeComponentState();

            this.showEmailButton = this.getShowEmailButton();
        },
        showUpgrade() {
            this.$bus.$emit('openAppDialog','premium', {'referrer': 'smart_showupgrade'});
        },
        showInfo(info) {
            alert(info);
        },

        getToolbarItemsDefault() {
            const items = [];

            let showBack = false;
            if (this.showOverview) showBack = true;
            if (!this.showSelector) showBack = true;

            items.push({
                key: "animation",
                icon: showBack ? "chevron_left" : "play_circle_outline",
                text: showBack ? "" : this.$t('plan_simple.btn_play'),
                //iconStyle: showBack ? "margin-top: 8px;" : "font-size: 32px; margin-bottom: 8px; margin-top: 4px; color: rgba(0,0,0,.7)!important;",
                iconStyle: showBack ? "" : "color: #2962ff!important;",
                iconClass: showBack ? "app-back-button-icon" : "",
                active: !showBack,
                callback: () => {
                    if (showBack) {
                        this.showOverview = false;
                        this.showSelector = true;
                        this.videoViewDialog = false;
                        this.selectedDetails = "";
                        this.updateToolbar();
                        this.$refs.treatmentSelector.scrollTop();
                        window.Tracker.screenView("home");
                    } else {
                        if (this.$store.state.networkStatus === "offline") {
                            this.showOfflineSnackbar();
                            return;
                        }
                        if (this.steps.length === 0) {
                            this.$bus.$emit("app.showSnackbar", {text: this.$t("plan_calculator.add_treatment")});
                            return;
                        }
                        this.animationData = PlanAnimationService.getData(this.steps, this.$store.state.simplePlan.status, this.$store.state.simplePlan.extraSteps);
                        this.animationViewDialog = true;
                        window.incrementLocalStorageForAnalyticsProp("animations_played");
                    }
                },
            });

            items.push({
                key: "options",
                icon: "currency_usd",
                text: this.$t("plan_simple.prices"),
                active: !this.showSelector,
                callback: (btn) => {
                    if (this.selectedDetails !== "") return;
                    window.Tracker.screenView("prices");
                    window.incrementLocalStorageForAnalyticsProp("calcs_created");
                    this.openDetails();
                    btn.active = true;
                },
            });

            items.push({
                key: "videos",
                icon: "movie_open_outline",
                active: false,
                text: this.$t("menu.videos"),
                callback: (btn) => {
                    this.$router.push("/animations");
                },
            });

            items.push({
                key: "reset",
                icon: "reset",
                text: this.$t("core.reset"),
                callback: () => {
                    this.reset();
                },
            });

            return ([items]);
        },

        getToolbarItemsPersonalized() {
            const items = [];

            let showBack = false;
            if (this.showOverview) showBack = true;
            if (!this.showSelector) showBack = true;

            items.push({
                key: "animation",
                icon: "play_circle_outline",
                text: this.$t('plan_simple.btn_play'),
                iconStyle: "",
                iconClass: "",
                active: false,
                callback: () => {

                        if (this.$store.state.networkStatus === "offline") {
                            this.showOfflineSnackbar();
                            return;
                        }

                        if (this.steps.length === 0) {
                            this.$bus.$emit("app.showSnackbar", {text: this.$t("plan_calculator.add_treatment")});
                            return;
                        }

                        this.animationData = PlanAnimationService.getData(this.steps, this.$store.state.simplePlan.status, this.$store.state.simplePlan.extraSteps);
                        this.animationViewDialog = true;

                        window.incrementLocalStorageForAnalyticsProp("animations_played");

                },
            });

            items.push({
                key: "options",
                icon: "currency_usd",
                text: this.$t("plan_simple.prices"),
                active: !this.showSelector,
                callback: (btn) => {

                    if (!localStorage.getItem('pricelistTutorial')) {
                        this.$bus.$emit('openAppDialog','pricelistTutorial');
                        localStorage.setItem('pricelistTutorial', 1);
                    }

                    if (this.selectedDetails !== "") return;
                    window.Tracker.screenView("prices");
                    window.incrementLocalStorageForAnalyticsProp("calcs_created");
                    this.openDetails();
                    btn.active = true;
                    this.updateToolbar();
                },
            });

            items.push({
                key: "reset",
                icon: "reset",
                text: this.$t("core.reset"),
                callback: () => {
                    this.reset();
                },
            });

            items.push({
                back: true,
                // disabled: !this.selectedDetails,
                callback: () => {
                    if (!this.selectedDetails) {
                        this.$router.push("/");
                    } else {
                        this.showOverview = false;
                        this.showSelector = true;
                        this.videoViewDialog = false;
                        this.selectedDetails = "";
                        this.updateToolbar();

                        // Scroll treatment buttons to top
                        this.$refs.treatmentSelector.scrollTop();
                        window.Tracker.screenView("home");
                    }
                },
            });

            return ([items]);
        },

        async printPlan() {

            if (!window.IAP.hasAccessToComponent('pdf')) {
                // this.$bus.$emit('extra-features-dialog:show');
                this.$bus.$emit('openAppDialog','premium', { 'referrer': 'auto_smart_pdf'});
                return;
            }

            if (this.printDialogVisible) return;

            this.$bus.$emit("app.showSnackbar", {color: "blue", text: "Generating PDF...", timeout: 30000});

            this.animationData = PlanAnimationService.getData(this.steps, this.$store.state.simplePlan.status, this.$store.state.simplePlan.extraSteps);

            this.printDialogVisible = true;
            await Vue.nextTick();
            console.log(this.$refs);
            await this.$refs['smartPdfTemplate'].getAnimationUrl();
            let content = document.getElementById("pdf-content").innerHTML;

            await request
                .post("https://denticalcsrvc.planmaster.hu/pdfPrint")
                .send({
                    footer: "",
                    content: content,
                })
                .withCredentials(false)
                .set("accept", "text/html")
                .then((resp) => {
                    this.$bus.$emit("app.hideSnackbar");
                    console.log(resp.body);
                    if (typeof resp.body !== 'undefined' && typeof resp.body.preview !== 'undefined' && resp.body.preview.length > 0) {
                        // this.pdfData = resp.body;
                        this.savePlanData({ pdfUrl: resp.body.url, pdfPages: resp.body.pages });
                        this.$bus.$emit('openAppDialog', 'pdfViewerGdocs', { pdfUrl: resp.body.url, pdfPages: resp.body.pages });
                    }
                    else this.$bus.$emit("app.showSnackbar", {color: "red", text: "Error creating PDF"}, 6);
                })
                .catch((error) => {
                    console.error(error);
                    captureException(error);
                    this.$bus.$emit("app.showSnackbar", {color: "red", text: "Error creating PDF"}, 6);
                }).finally(() => {
                    this.printDialogVisible = false;
                });

            this.printDialogVisible = false;
        },


        getShowEmailButton() {
            return true;
        },
        emailSent() {
            this.$set(this.$store.state.simplePlan, "emailSent", true);
            window.incrementLocalStorageForAnalyticsProp("emails_sent");
        },
        sendPlan() {
            if (!window.IAP.hasAccessToComponent('email')) {
                // this.$bus.$emit('extra-features-dialog:show');
                this.$bus.$emit('openAppDialog','premium', { 'referrer': 'auto_smart_send'});
                return;
            }

            // this.animationData = PlanAnimationService.getData(this.steps, this.status);
            this.animationData = PlanAnimationService.getData(this.steps, this.$store.state.simplePlan.status, this.$store.state.simplePlan.extraSteps);
            this.emailDialogVisible = true;

            this.sendAnalytic();
        },
        /** @type {() => void} */
        sendAnalytic() {
            window.Tracker.setUserProperty("interested_in_email_send", 1, {
                event_name: "interested_in_email_send",
                event_label: "interest",
                event_value: 1,
            });
        },
        getCurrentPlanId(idx) {
            if (typeof this.planIdMap[idx] === 'undefined' || this.planIdMap[idx] === '') {
                this.planIdMap[idx] = this.getAvailablePlanId();
            }
            return this.planIdMap[idx];
        },
        setPlanId() {
            this.planIdMap[this.activePlan] = this.getAvailablePlanId();
            // alert(this.planIdMap.join(","));
        },
        getAvailablePlanId() {
            let newPlanId = '';
            if (!this.planIdMap.includes('a')) newPlanId = 'a';
            else if (!this.planIdMap.includes('b')) newPlanId = 'b';
            else if (!this.planIdMap.includes('c')) newPlanId = 'c';
            return newPlanId;
        },
        getOptionPrice(option) {
            try {
                return this.$store.state.localSettings.protocols[option.tpl].variation_prices[option.variation_index][this.$store.state.localSettings.currency] || 0;
            } catch(error) {
                captureException(error);
                return 0;
            }
        },
        exchangePrices() {
            let extraTotal = 0;
            this.$store.state.simplePlan.extraSteps.forEach((step)=>{
                step.unit_price = this.$store.getters["smart/priceOfTreatment"](step.state_id, this.$store.state.currency);
                extraTotal += step.unit_price * step.amount;
            });
            this.$set(this.$store.state.simplePlan, "extraTotal", extraTotal);

            this.steps.forEach((step) => {
                if (step.options && step.options.length > 0) {
                    step.options.forEach((opt)=>{
                        if (typeof opt.variation_index !== "undefined") {
                            opt.price = this.getOptionPrice(opt);
                            opt.unit_price = parseFloat(opt.price) / parseInt(opt.amount);
                        } else {
                            opt.unit_price = this.$store.getters["smart/priceOfTreatment"](opt.state_id, this.$store.state.currency);
                            opt.price = parseFloat(opt.unit_price) * parseInt(opt.amount);
                        }
                    });
                }
            });

            this.$set(this.$store.state.simplePlan, "upperJawTotal", this.$store.getters["simplePlan/totalForJaw"]("upper", true));
            this.$set(this.$store.state.simplePlan, "lowerJawTotal", this.$store.getters["simplePlan/totalForJaw"]("lower", true));

            this.currency = this.$store.state.currency;
        },
        treatmentSettingsUpdated() {
            this.$refs["pmRegionSelector"].update();
            this.storeComponentState();
        },
        storeComponentState() {
            try {
                this.storePlan(this.activePlan);
                localStorage.setItem("storedState", JSON.stringify({
                    planIdMap: this.planIdMap,
                    plans: this.plans,
                    // Add timestamp for plan for checking maximum load time.
                    timestamp: Date.now(),
                    // activePlan: this.activePlan,
                    // steps: this.steps,
                    // status: this.status,
                    // showOverview: this.showOverview,
                    // selectedDetails: this.selectedDetails,
                    // selectedRegions: this.selectedRegions,
                    // selectedRegion: this.selectedRegion,
                    // showSelector: this.showSelector,
                    // simplePlanStore: this.$store.state.simplePlan,
                }));

            } catch(error) {
                captureException(error);
            }
        },
        loadPlanData(plan) {
            Object.keys(plan).forEach((key) => {
                this.$set(this.$store.state.simplePlan, key, plan[key]);
                this.steps = plan.steps;
                this.status = plan.status;
            });
            this.$set(this.$store.state.simplePlan, "upperJawTotal", this.$store.getters["simplePlan/totalForJaw"]('upper', true));
            this.$set(this.$store.state.simplePlan, "lowerJawTotal", this.$store.getters["simplePlan/totalForJaw"]('lower', true));
            this.$refs["pmRegionSelector"].selectArea(this.$store.state.simplePlan.selectedRegion);
            this.selectedRegions[0] = this.$store.state.simplePlan.selectedRegion;
        },
        async loadComponentState() {
            if (window.loadFromHistory) {
                return;
            }

            const json = localStorage.getItem("storedState");

            if (!json) {
                return;
            }

            const data = JSON.parse(json);

            if (typeof data.timestamp === "undefined") {
                return;
            }

            const millisDiff = Date.now() - data.timestamp;
            const minutesDiff = millisDiff / 1000 / 60;

            if (minutesDiff > MINUTES_THRESHOLD) {
                return;
            }

            this.loadingComponentState = true;

            if (this.plans.length > 0) {
                this.plans.splice(0, this.plans.length);
            }

            this.plans = [...new Set(data.plans)];

            this.planIdMap = typeof data.planIdMap !== "undefined" ?
                data.planIdMap :
                ["a", "b", "c"].slice(0, this.plans.length);

            this.loadPlanData(JSON.parse(this.plans[0]));

            this.loadingComponentState = false;

            await this.$nextTick();

            this.$refs["pmTreatmentSettings"].update();
            this.$refs["pmRegionSelector"].update();
            this.$refs["pmRegionSelector"].$forceUpdate();
        },


        savePlanData(extraData = {}) {
            const data = {
                extraPercentage: this.$store.state.simplePlan.fullTotal - this.$store.state.simplePlan.upperJawTotal -this.$store.state.simplePlan.lowerJawTotal - this.$store.state.simplePlan.extraTotal,
                component: "plan",
                timestamp: Date.now(),
                data: JSON.stringify(this.$store.state.simplePlan),
                totalUpper: this.$store.state.simplePlan.upperJawTotal,
                totalLower: this.$store.state.simplePlan.lowerJawTotal,
                extraTotal: this.$store.state.simplePlan.extraTotal,
                titleUpper: this.$store.state.simplePlan.upperJawTitle,
                titleLower: this.$store.state.simplePlan.lowerJawTitle,
                currency: this.$store.state.currency,
                discountMode: this.$store.state.simplePlan.discountMode,
                discountAmount: this.$store.state.simplePlan.discountAmount,
            };

            const finalData = Object.assign(data, extraData);

            historyDb.store(finalData);

            this.$store.commit("pushToHistory", finalData);
        },

        save() {
            if (!window.IAP.hasAccessToComponent('history')) {
                this.$bus.$emit('openAppDialog','premium', { 'referrer': 'auto_smart_save'});
                return;
            }

            this.savePlanData();

            this.$bus.$emit("app.showSnackbar", {color: "blue", text: this.$t("plan_simple.plan_saved")});
            this.storeComponentState();

            window.Tracker.logEvent({
                event_name: "calc_saved",
                event_category: "calc",
                event_label: "Calc",
            });

            return;

            window.incrementLocalStorageForAnalyticsProp("plans_saved");
        },


        callMethod(name, ...params) {
            this[name].call(this, ...params);
        },

        openDetails() {
            this.selectedDetails = this.$store.state.simplePlan.selectedJaw || "extras";
            // this.selectedDetails = "total";
            // this.showOverview = true;
            this.showSelector = false;

            this.updateToolbar();
        },

        selectArea(areas) {
            this.selectedRegions = areas;
        },

        setSelectedRegion(r) {
            this.selectedRegions = [r];
            this.$refs["pmRegionSelector"].selectArea(r);
        },

        jawHasTreatmentByRegion(region) {
            if (typeof region === "undefined") return false;
            const jaw = region < 3 ? "upper": "lower";
            for (const i in this.steps) {
                if (this.steps[i].jaw === jaw) return true;
            }
            return false;
        },


        handleActivePlanChange(newValue, prevValue) {
            if (this.loadingComponentState || window.loadFromHistory) return;

            // Process previous plan data. Store only non-deletable plan.
            if (this.deletePlanIdx === prevValue) {
                this.deletePlanIdx = -1;
                this.plans.splice(prevValue, 1);
                if(typeof this.planIdMap[prevValue] !== 'undefined') this.planIdMap.splice(prevValue, 1);
            } else {
                this.storePlan(prevValue);
            }

            // Create new plan or load existing plan
            if (typeof this.plans[this.activePlan] === "undefined") {
                this.plans[this.activePlan] = {};
                this.setPlanId();
                this.$set(this.$store.state.simplePlan, "emailSent", false);
                this.$store.commit("simplePlan/reset");
                this.steps = this.$store.state.simplePlan.steps;
                this.status = this.$store.state.simplePlan.status;
                this.$refs["pmRegionSelector"].deselect();
                this.selectedRegions.splice(this.selectedRegions.length, 1);
            } else {
                const plan = JSON.parse(this.plans[this.activePlan]);

                this.$set(this.$store.state.simplePlan, "emailSent", false);

                Object.keys(plan).forEach((key) => {
                    this.$set(this.$store.state.simplePlan, key, plan[key]);

                    this.steps = plan.steps;
                    this.status = plan.status;
                });

                this.$refs["pmRegionSelector"].selectArea(this.$store.state.simplePlan.selectedRegion);

                this.selectedRegions[0] = this.$store.state.simplePlan.selectedRegion;
            }

            this.$forceUpdate();
            this.$refs["pmTreatmentSettings"].update();
            this.updateToolbar();
            this.$nextTick(()=>{
                // this.$refs["pmRegionSelector"].deselect();
                this.$refs["pmRegionSelector"].update();
                this.$refs["pmRegionSelector"].$forceUpdate();
            });
            this.storeComponentState();
        },

        deletePlan(planIdx) {
            // this.plans[planIdx].deleted = true;
            if (planIdx === 0) {
                this.plans[0] = this.plans[1];
                this.plans.splice(1, 1);
                this.deletePlanIdx = 1;
                this.activePlan = 0;
                this.planIdMap[0] = this.planIdMap[1];
                this.handleActivePlanChange(0, 1);
                return;
            } else {
                this.deletePlanIdx = planIdx;
                this.activePlan = planIdx - 1;
            }

            window.Tracker.logEvent({
                event_name: "calc_deleted",
                event_category: "calc",
                event_label: "Calc",
            });
        },

        storePlan(planIdx) {
            this.plans[planIdx] = JSON.stringify(this.$store.state.simplePlan);
        },

        createPlan(cloned = false) {
            if (this.plans.length > 2) {
                this.$bus.$emit("app.showSnackbar", {text: this.$t("plan_calculator.plan_limit_reached")});
                return false;
            }
            this.activePlan = this.plans.length;
            this.$nextTick(()=> {
                this.$refs["pmRegionSelector"].reset();
                this.$refs["pmRegionSelector"].update();
                this.showOverview = false;
                this.showSelector = true;
                this.videoViewDialog = false;
                this.selectedDetails = "";
                this.updateToolbar();
            });

            window.Tracker.logEvent({
                event_name: cloned ? "calc_cloned" : "calc_created",
                event_category: "calc",
                event_label: "Calc",
            });
        },

        reset() {
            this.$set(this.$store.state.simplePlan, "emailSent", false);

            if (this.selectedDetails && !['upper', 'lower', 'extras', 'total'].includes(this.selectedDetails)) {
                return document.querySelector("#pm-toolbar-item--0").click();
            }

            // Allow reset only on odontogram view + extras
            if (this.selectedDetails !== "" && this.selectedDetails !== "extras") {
                this.selectedDetails = "";
                this.showOverview = false;
                this.showSelector = true;
                this.updateToolbar();
                return
            }

            const reseted = PlanResetService.reset(this.steps, this.status, this.selectedDetails);
            if (reseted === "extras") return;

            this.$store.state.simplePlan.allowImplantRecalc = false;
            this.$store.state.simplePlan.availableTreatmentPids = [];
            this.selectedRegions = [];
            // this.showOverview = false;
            // this.showSelector = true;
            // this.showSelectorLarge = false;
            this.$nextTick(()=> {
                this.$refs["pmRegionSelector"].reset();
                this.$refs["pmRegionSelector"].update();
                this.updateToolbar();
            });
            this.storeComponentState();

            window.Tracker.logEvent({
                event_name: "calc_reseted",
                event_category: "calc",
                event_label: "Calc",
            });
        },

        selectTreatment(item) {
            this.$set(this.$store.state.simplePlan, "emailSent", false);
            const t = new Date().getTime();

            this.$refs["pmTreatmentSettings"].preventReload();

            if (!this.validateTreatment(item.template)) return false;
            const jaw = this.$store.state.simplePlan.selectedJaw;
            const tpl = JSON.parse(JSON.stringify(item.template));
            if (typeof tpl.active_tab !== "undefined") window.lastTplActiveTab = tpl.active_tab;

            // Get steps and status
            const steps = SimplePlanService.getSteps(tpl, this.$store.state.simplePlan.selectedRegion);
            const status = SimplePlanService.getStatus(tpl, this.$store.state.simplePlan.selectedRegion);

            // Cleanup previous steps, merge new steps and status
            this.$store.state.simplePlan.allowImplantRecalc = typeof tpl.allowImplantRecalc !== "undefined" && parseInt(tpl.allowImplantRecalc) === 1 && SimplePlanService.getStepByPid(15, jaw, this.steps) === null;
            SimplePlanService.cleanupSteps(tpl, this.steps, jaw);
            SimplePlanService.mergeSteps(this.steps, steps, tpl);
            this.$set(this.$store.state.simplePlan, "steps", this.steps);
            PlanSimpleStatusGenerator.addStatus(status, jaw, tpl, this.steps);
            this.$set(this.$store.state.simplePlan, jaw+"JawTotal", this.$store.getters["simplePlan/totalForJaw"](jaw, true));
            if (tpl.full_jaw) this.$store.state.simplePlan[jaw + "Tpl"] = tpl;
            this.$store.state.simplePlan.activeTreatmentPid = tpl.variations_by;

            this.$refs["pmRegionSelector"].update();



            // this.$refs["pmRegionSelector"].selectArea(this.$store.state.simplePlan.selectedRegion); // Required to prevent unresponsive UI adding treatments to the same region without re-selecting it.

            // this.$forceUpdate();
            this.storeComponentState();
            this.$nextTick(()=>{
                this.$refs["pmTreatmentSettings"].unpreventReload();
                this.$refs["pmTreatmentSettings"].update();
                this.$refs["pmTreatmentSettings"].setSelectedRegion(this.$store.state.simplePlan.selectedRegion);
                const t2 = new Date().getTime();
            });

            try {
                let cnt = localStorage.getItem('smartTreatmentSelectedCounter') || 0;
                cnt++;
                localStorage.setItem('smartTreatmentSelectedCounter', cnt);

                window.Tracker.setUserProperty('smart_treatment_selected_counter', cnt, {
                    event_name: 'smart_treatment_selected_counter',
                    event_label: 'smart_treatment_selected_counter',
                    event_value: cnt,
                });

            } catch (e) {
                captureException(e);
            }

            window.Tracker.logEvent({
                event_name: "treatment_selected",
                event_category: "treatment",
                event_label: tpl.title,
            });
        },

        validateTreatment(tpl) {
            // Show alert on empty selection
            if (this.$store.state.simplePlan.selectedRegion < 0) {
                this.$bus.$emit("app.showSnackbar", {text: this.$t("plan_calculator.select_region")});
                return false;
            }

            // Forbid combining one-phase and normal implants
            if (["crown_implants_one_phase", "bridge_implants_one_phase"].includes(tpl.title)) {
                const jaw = this.$store.state.simplePlan.selectedRegion < 3 ? "upper" : "lower";
                for (let i = 0; i < this.steps.length; i++) {
                    if (this.steps[i].jaw === jaw && parseInt(this.steps[i].state_id) === 11 && this.steps[i].animation_pid !== 10) {
                        this.$bus.$emit("app.showSnackbar", {text: this.$t("plan_calculator.do_not_combine_different_implant_types")});
                        return false;
                    }
                }
            }
            if (["crown_implants", "bridge_implants"].includes(tpl.title)) {
                const jaw = this.$store.state.simplePlan.selectedRegion < 3 ? "upper" : "lower";
                for (let i = 0; i < this.steps.length; i++) {
                    if (this.steps[i].jaw === jaw && parseInt(this.steps[i].animation_pid) === 10) {
                        this.$bus.$emit("app.showSnackbar", {text: this.$t("plan_calculator.do_not_combine_different_implant_types")});
                        return false;
                    }
                }
            }

            // Forbid combining any treatment with full-jaw treatment
            const prevTpl = this.$store.state.simplePlan[this.$store.state.simplePlan.selectedJaw + "Tpl"];
            if (prevTpl !== null && typeof prevTpl.full_jaw !== "undefined" && parseInt(prevTpl.full_jaw) === 1 && typeof tpl.allowOnFullJaw !== "undefined" && parseInt(tpl.allowOnFullJaw) === 0) {
                this.$bus.$emit("app.showSnackbar", {text: this.$t("plan_calculator.treatment_not_allowed")});
                this.$store.state.simplePlan.blinking = true;
                window.setTimeout(()=>{
                    this.$store.state.simplePlan.blinking = false;
                }, 3 * 800);
                return false;
            }

            //
            if (!tpl.full_jaw) {
                const treatable = SimplePlanService.getTreatableTeeth(this.$store.state.simplePlan.selectedRegion);
                if (treatable.length === 0) {
                    this.$bus.$emit("app.showSnackbar", {text: this.$t("plan_calculator.no_treatable_teeth_in_region")});
                    this.$store.state.simplePlan.blinking = true;
                    window.setTimeout(()=>{
                        this.$store.state.simplePlan.blinking = false;
                    }, 3 * 800);
                    return false;
                } else {
                    // alert(treatable.join(','));
                }
            }

            return true;
        },
        showOfflineSnackbar() {
            this.$bus.$emit("app.showSnackbar", {color: "blue", text: this.$t("core.offline")});
        },
        /**
         * @param {number} planId
         * @return {void}
         */
        clonePlan() {
            if (this.plans.length > 2) {
                return this.$bus.$emit("app.showSnackbar", {text: this.$t("plan_calculator.plan_limit_reached")});
            }

            this.createPlan(true);

            this.plans[this.activePlan] = JSON.stringify(this.$store.state.simplePlan);
            this.setPlanId();
            this.$nextTick(()=>{
                // this.openDetails();
            });
        },
    },
};
</script>
